import { render, staticRenderFns } from "./ReturnReasonTypes.vue?vue&type=template&id=4cae4d10&scoped=true&"
import script from "./ReturnReasonTypes.vue?vue&type=script&lang=js&"
export * from "./ReturnReasonTypes.vue?vue&type=script&lang=js&"
import style0 from "./ReturnReasonTypes.vue?vue&type=style&index=0&id=4cae4d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cae4d10",
  null
  
)

export default component.exports